import Counter from 'countdown-js';

export default class Countdown {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        Array.from(document.querySelectorAll('.countdown')).forEach(element => {
            new Countdown(element);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        let daysElement = this.element.querySelector('[data-type="days"]');
        let hoursElement = this.element.querySelector('[data-type="hours"]');
        let minutesElement = this.element.querySelector('[data-type="minutes"]');
        let secondsElement = this.element.querySelector('[data-type="seconds"]');
        let endDate = new Date(this.element.dataset.date);

        if (endDate.getTime() < new Date().getTime()) {
            daysElement.innerHTML = '0';
            hoursElement.innerHTML = '0';
            minutesElement.innerHTML = '0';
            secondsElement.innerHTML = '0';
            return;
        }

        this.timer = new Counter.timer(endDate, (timeLeft) => {
            daysElement.innerHTML = timeLeft.days;
            hoursElement.innerHTML = timeLeft.hours;
            minutesElement.innerHTML = timeLeft.minutes;
            secondsElement.innerHTML = timeLeft.seconds;
        });
    }
}
